import VueRouter from 'vue-router';

import select from '../components/ageContent/select';
import occurrence from '../pages/occurrence';
import agemodel from '../pages/agemodel';
import calibrations from '../pages/calibrations';
import stratigraphic from '../pages/stratigraphic';
import taxonomy from '../pages/taxonomy';
import info from '../components/ageContent/info';
import virtualdrilling from '../pages/virtualdrilling.vue';
import Tool from '../pages/tool.vue';
import Contact from '../pages/contact-1.vue';
import Depth from '../pages/depth.vue';
import Pad from '../pages/oae.vue';
import home from '../pages/home.vue';

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: 'home',
    },
    {
      name: 'home',
      path: '/home',
      component: home,
    },
    {
      name: 'occurrence',
      path: '/occur',
      component: occurrence,
    },
    {
      name: 'agemodel',
      path: '/age',
      component: agemodel,
      children: [
        {
          name: 'select',
          path: '/select',
          component: select,
        },
        {
          name: 'info',
          path: '/info',
          component: info,
        },
      ],
    },
    {
      name: 'calibrations',
      path: '/calib',
      component: calibrations,
    },
    {
      name: 'stratigraphic',
      path: '/strat',
      component: stratigraphic,
      children: [
        {
          name: 'stratlist',
          path: 'stratlist',
          props: true,
          component: () => import('@/components/stratContent/stratlist.vue'),
        },
      ],
    },
    {
      name: 'taxonomy',
      path: '/tax',
      component: taxonomy,
    },
    {
      name: 'virtualdrilling',
      path: '/vd',
      component: virtualdrilling,
    },
    {
      name: 'tools',
      path: '/tools',
      component: Tool,
    },
    {
      name: 'help',
      path: '/help',
      component: Contact,
    },
    {
      name: 'depth',
      path: '/depth',
      component: Depth,
    },
    {
      name: 'pad',
      path: '/pad', // 配置/oae路径
      component: Pad
    },
  ],


});
